<template>
  <div
    :class="['container', _isMobile() ? 'mobile' : '']"
    :style="{
      background: tenantConfig.homeBgColor,
      'background-image': 'url(' + tenantConfig.homeBg + ')',
      'background-repeat': tenantConfig.homeBgRepeat,
    }"
  >
  
    <Header id="header" />
    <div class="cms">
      <a-row type="flex" :gutter="[24,24]">
        <a-col flex="auto">
            <div class="cms-content">
                <router-view />
            </div>
        </a-col>
        <a-col v-if="tenantConfig.sideContent" flex="300px">
          <div class="cms-side" v-html="tenantConfig.sideContent"></div>
        </a-col>
      </a-row>
    </div>

    <a-back-top />
    <Footer />
  </div>
</template>
  
  <script>
import { mixinDevice } from "@/utils/mixin.js";
import Header from "@/components/header/HeaderWayi";
import Header2 from "@/components/header/Header2";
import Header3 from "@/components/header/Header3";
import Footer from "@/components/footer/Footer";
export default {
  name: "CmdLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Header2,
    Header3,
    Footer,
  },
  data() {
    return {
      tenantConfig: {
        sideContent: "",
      },
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
  },
};
</script>
  <style>
a * {
  transition: all 0.1s ease;
}
</style>
  <style lang="less" scoped>
.container {
  background: #f2f6f8;
  // padding-top: 90px;
  .cms {
    max-width: 1200px;
    margin: 20px auto 20px;

  }
  .cms-content{
    padding: 20px;
    background: #ffffffd1;
    border-radius: 30px;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
  .cms-side {
    width: 300px;
    overflow: hidden;
  }
}
</style>